<script>
import { authComputed,merchantComputed } from "@store/helpers";
import { memberLevelPriceDiscount } from "@utils/ipetbooking-level";

export default {
  components: {	
    InfoBoxReservation: () => import('../../Index/InfoBoxContainerReservation.Jtails'),	
    InfoBoxPrepaid: () => import('../../Index/InfoBoxPrepaid.Jtails'),	
  },
  props: {
    orderItem: {
      type: Object,
      required: true
    },
    orderType: {
      type: String,
      required: true,
      validator(value) {
        return [
          'reservation',
          'prepaid',
          'children',	
          'deposit',
        ].includes(value)
      },
    },
    status: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: ''
    },
    responseError: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    isCurrentMemberOrder() {
      return this.currentMember?.id === this.orderItem?.memberId
    },
    tempCart() {	
      return this.$store.state.cart.tempCart	
    },	
    showContinueCheckout() {	
      return !!this.tempCart	
    },	
    submitData() {	
      return this.$store.state.cart.tempCart?.submitData || {}	
    },	
    cart() {	
      return this.$store.state.cart.tempCart?.cart || {}	
    },	
    isUnpaid() {	
      return !!this.tempCart?.isUnpaid	
    },	
    cartTotal() {	
      return this.tempCart?.cartTotal ?? 0	
    },	
    cartType() {	
      return this.tempCart?.cartType || 'reservation'	
    },	
    	
    showCoupon() {	
      return !!this.tempCart?.showCoupon ?? false;	
    },	
    couponDiscount() {	
      return this.tempCart?.couponDiscount || 0;	
    },	
    prepaidInfo() {	
      return this.tempCart?.prepaidInfo || {};	
    },	
    isFreeOrder() {	
      return this.cartTotal === 0;	
    },	
    componentInfoBox() {	
      const componentInfoBoxMap = {	
        'reservation': 'InfoBoxReservation',	
        'prepaid': 'InfoBoxPrepaid',	
      };	
      return componentInfoBoxMap[this.cartType]	
    },
  },
  methods: {
    replaceToReservationCheckoutDetail() {
      const loggedInFn = (isLogin) => {
        this.$router.replace({
          name: 'reservation-checkout-detail',
          params: {
            orderId: this.$route.params.orderId
          },
          query: isLogin
            ? {
              status: 'SUCCESS',
              message: '',
              type: 'login'
            }
            : {}
        })
      };

      if(this.isLoggedIn) {
        loggedInFn(false)
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            this.$nextTick(() => {
              loggedInFn(true)
            })
          }
        })
      }
    },
    replaceToPrepaidCheckoutDetail() {
      const loggedInFn = (isLogin) => {
        this.$router.replace({
          name: 'prepaid-checkout-detail',
          params: {
            orderId: this.$route.params.orderId
          },
          query: isLogin
            ? {
              status: 'SUCCESS',
              message: '',
              type: 'login'
            }
            : {}
        })
      };

      if(this.isLoggedIn) {
        loggedInFn(false)
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            this.$nextTick(() => {
              loggedInFn(true)
            })
          }
        })
      }
    },
    replaceToDepositCheckoutDetail() {	
      const loggedInFn = (isLogin) => {	
        this.$router.replace({	
          name: 'deposit-checkout-detail',	
          params: {	
            containerUuId: this.$route.params.containerUuId	
          },	
          query: isLogin	
            ? {	
              status: 'SUCCESS',	
              message: '',	
              type: 'login'	
            }	
            : {}	
        })	
      };	
      if(this.isLoggedIn) {	
        loggedInFn(false)	
      } else {	
        this.$globalDialog('DialogLogin', {	
          callbackLogin: () => {	
            this.$nextTick(() => {	
              loggedInFn(true)	
            })	
          }	
        })	
      }	
    },	
    async tryToStoreCart(data) {	
      await this.$store.dispatch('cart/storeCart', data)	
        .then(() => {	
          return true	
        })	
    },	
    goToUnfinishCheckout() {	
      const { cart, submitData, isUnpaid } = this.$store.state.cart.tempCart	
      const type = cart.prepaid ? 'prepaid' : 'reservation'	
      const cartData = type === 'reservation' 	
        ? {	
            
          }	
        : {	
            prepaidAlias: cart.prepaid.alias	
          }	
      const goToCheckout = () => {	
        const to = {	
          name: `${type}-${isUnpaid ? 'unpaid-' : ''}checkout`,	
          params: {	
            [`${type}Alias`]: type === 'reservation' ? cart.uuid : cart.prepaid.alias,
            storeType: type === 'reservation' ? undefined : cart.prepaid.stores[0].storeType,
            containerUuId: type === 'reservation' ? cart.uuid : ''
          },	
          query: {	
            clearTempCart: true,	
          }	
        }	
        if (isUnpaid)	
          if (type !== 'reservation') {
            to.params.orderId = cart.id	
          }
        this.$router.replace(to)	
      };	
      const loggedInFn = () => {	
        const loadingMaskCheckOutCart = this.$loading({	
          lock: true,	
          text: '正在前往結帳',	
          spinner: `fal fa-circle-notch fa-spin`,	
          background: 'rgba(81, 176, 202, 0.3)',	
          customClass: 'isStyleCheckout'	
        });	
        if (isUnpaid)	{
          goToCheckout()	
          loadingMaskCheckOutCart.close()	
        }
        else if (type === 'reservation') {
          goToCheckout()	
          loadingMaskCheckOutCart.close()	
        }
        else  {
          this.tryToStoreCart(cartData)	
            .then(() => {	
              goToCheckout()	
            })
            .catch((e) => {
              if(e.status === 'STATUS_CODE_UNDEFINED') {
                this.$globalDialog('DialogBlock', {})
              }
            })	
            .finally(() => {	
              loadingMaskCheckOutCart.close()	
            })	
        }
      };	
      if(this.isLoggedIn) {	
        loggedInFn()	
      } else {	
        this.$globalDialog('DialogLogin', {	
          callbackLogin: () => {	
            this.$nextTick(() => {	
              loggedInFn()	
            })	
          }	
        })	
      }	
    },
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.checkoutDetailCallback" class="container--callback">
    <div class="section text-center">
      <template v-if="status === 'SUCCESS'">
        <div class="mb-12">
          <img class="mb-4" alt="" :src="require(`@assets/images/${$globalProjectName}/reservation/checkout-success.svg`)" style="max-width: 100%">
          <div class="checkoutDetailCallback__title">
            <template v-if="orderType === 'reservation'">
              預約完成
            </template>
            <template v-if="orderType === 'prepaid'">
              <template v-if="orderItem.paymentMethod === 'Vacc'">
                訂單成立
              </template>
              <template v-else>
                結帳完成
              </template>
            </template>
            <template v-if="orderType === 'children'">
              結帳完成
            </template>
            <template v-if="orderType === 'deposit'">	
              <template v-if="['Vacc', 'Atm', 'Cash'].includes(orderItem.paymentMethod)">	
                訂單成立	
              </template>	
              <template v-else>	
                儲值成功	
              </template>	
            </template>
          </div>
          <div class="checkoutDetailCallback__description">
            <template v-if="orderType === 'reservation'">
              <template v-if="orderItem.paymentMethod === 'Vacc'">
                感謝您的預約！您的訂單已成立。<br class="d-md-none">我們已寄發匯款方式至{{
                  isCurrentMemberOrder
                    ? '您'
                    : '使用人'
                }}的電子郵件。
              </template>
              <template v-else>
                感謝您的預約！您的訂單已成立。<span v-if="isCurrentMemberOrder"><br class="d-md-none">可至會員中心查看預約明細。</span>
              </template>
            </template>
            <template v-if="orderType === 'prepaid'">
              <template v-if="orderItem.paymentMethod === 'Vacc'">
                感謝您的購買！您的訂單已成立。<br class="d-md-none">我們已寄發匯款方式至{{
                  isCurrentMemberOrder
                    ? '您'
                    : '使用人'
                }}的電子郵件。
              </template>
              <template v-else>
                感謝您的購買！您的訂單已成立。
              </template>
            </template>
            <template v-if="orderType === 'children'">
              <template v-if="orderItem.paymentMethod === 'Vacc'">
                感謝您的購買！您的訂單已成立。<br class="d-md-none">我們已寄發匯款方式至{{
                  isCurrentMemberOrder
                    ? '您'
                    : '使用人'
                }}的電子郵件。
              </template>
              <template v-else>
                感謝您的購買！您的訂單已成立。
              </template>
            </template>
            <template v-if="orderType === 'deposit'">	
              <template v-if="['Vacc', 'Atm', 'Cash'].includes(orderItem.paymentMethod)">	
                感謝您的購買！您的訂單已成立。<br class="d-md-none">我們已寄發匯款方式至{{	
                  isCurrentMemberOrder	
                    ? '您'	
                    : '使用人'	
                }}的電子郵件。	
              </template>	
              <template v-else>	
                感謝您的儲值！您的儲值金已成立。我們已寄發儲值明細至您的電子郵件。	
              </template>	
            </template>
          </div>
        </div>
        <!--本人訂單-->
        <template v-if="isCurrentMemberOrder">
          <!--預約-->
          <template v-if="orderType === 'reservation'">
            <BaseButton
              class="isStylePrimary isCol4"
              :class="{ 'isRadius': $globalIsJtails }"
              @click="replaceToReservationCheckoutDetail"
            >
              <span v-if="!isLoggedIn">登入</span>查看預約結果
            </BaseButton>
          </template>
          <!--包套方案-->
          <template v-if="orderType === 'prepaid'">
            <BaseButton
              class="isStylePrimary isCol4"
              :class="{ 'isRadius': $globalIsJtails }"
              @click="replaceToPrepaidCheckoutDetail"
            >
              <span v-if="!isLoggedIn">登入</span>查看購買結果
            </BaseButton>
          </template>
          <!--子訂單-->
          <template v-if="orderType === 'children'">
            <BaseButton
              class="isStylePrimary isCol4"
              :class="{ 'isRadius': $globalIsJtails }"
              @click="replaceToReservationCheckoutDetail"
            >
              <span v-if="!isLoggedIn">登入</span>查看訂單結果
            </BaseButton>
          </template>
          <!--儲值金-->	
          <template v-if="orderType === 'deposit'">	
            <template v-if="showContinueCheckout && orderItem.paymentMethod === 'Credit'">	
              <component	
                :is="componentInfoBox"	
                :class="$style.previousCart"	
                :cart="cart"	
                :submit-data.sync="submitData"	
                :cart-total="cartTotal"	
                :is-free-order="isFreeOrder"	
                :is-unpaid="isUnpaid"	
                :show-coupon="showCoupon"	
                :coupon-discount="couponDiscount"	
                :prepaid-info="prepaidInfo"
              />	
              <BaseButton	
                class="isStylePrimary isFull mb-3"	
                :class="{ 'isRadius': $globalIsJtails }"
                @click="goToUnfinishCheckout"	
              >	
                繼續完成訂單	
              </BaseButton>	
              <BaseButton	
                class="isStylePrimary isOutline3 isFull mb-3"	
                :class="{ 'isRadius': $globalIsJtails }"
                @click="replaceToDepositCheckoutDetail"	
              >	
                取消	
              </BaseButton>	
            </template>	
            <BaseButton	
              v-else	
              class="isStylePrimary isCol4"
              :class="{ 'isRadius': $globalIsJtails }"	
              @click="replaceToDepositCheckoutDetail"	
            >	
              <span v-if="!isLoggedIn">登入</span>查看儲值結果	
            </BaseButton>	
          </template>
        </template>
        <!--非本人訂單-->
        <template v-else>
          <BaseButton
            class="isStylePrimary isCol4"
            :class="{ 'isRadius': $globalIsJtails }"
            :to="{ name: 'home' }"
          >
            回首頁
          </BaseButton>
        </template>
      </template>
      <template v-else-if="status === 'EXPIRED'">
        <div class="mb-12">
          <img class="mb-4" alt="" :src="require(`@assets/images/${$globalProjectName}/reservation/checkout-time-out.svg`)">
          <div class="checkoutDetailCallback__title">
            逾時結帳，付款未成功
          </div>
          <div class="checkoutDetailCallback__description">
            親愛的客戶，您的訂單已逾時，造成結帳未成功，請您重新再試。
            <br><span class="text-danger">提醒您，請在15分鐘內完成結帳，以免訂單逾時。</span>
          </div>
        </div>
        <template v-if="orderType === 'reservation'">
          <BaseButton
            :to="{ name: 'reservation-item', params: { productAlias: orderItem.product.alias, reservationAlias: orderItem.param.alias } }"
            replace
            class="w-full"
            is-style="primary"
          >
            回服務資訊頁
          </BaseButton>
        </template>
        <template v-if="orderType === 'prepaid'">
          <BaseButton
            :to="{ name: 'prepaid-item', params: { prepaidAlias: orderItem.prepaid.alias } }"
            replace
            class="isStylePrimary isCol4"
            :class="{ 'isRadius': $globalIsJtails }"
          >
            {{`回${currentMerchant.prepaidSetting.title || '包套方案'}資訊頁`}}
          </BaseButton>
        </template>
        <template v-if="orderType === 'children'">
          <BaseButton
            :to="{ name: 'reservation-checkout-detail', params: { addOrderId: orderItem.id } }"
            replace
            class="isStylePrimary isCol4"
            :class="{ 'isRadius': $globalIsJtails }"
          >
            返回訂單
          </BaseButton>
        </template>
        <template v-if="orderType === 'deposit'">	
          <BaseButton	
            :to="{ name: 'deposit' }"	
            replace	
            class="isStylePrimary isCol4"	
            :class="{ 'isRadius': $globalIsJtails }"
          >	
            回儲值金方案頁	
          </BaseButton>	
        </template>
      </template>
      <template v-else>
        <div>
          <div class="mb-12">
            <img class="mb-4" alt="" :src="require(`@assets/images/${$globalProjectName}/reservation/checkout-fail.svg`)">
            <div class="checkoutDetailCallback__title">
              結帳失敗
            </div>
            <template v-if="message">
              <div class="fs-6 text-danger leading-loose">
                {{ message }}
              </div>
            </template>
            <template v-else>
              <div class="checkoutDetailCallback__description mb-4 text-danger">
                親愛的客戶，您的信用卡扣款失敗，請重新再試。
              </div>
              <div class="text-left fs-6"
                   style="padding: 1.875rem;background: rgb(216, 224, 229, 0.15);border-radius: 20px;">
                <div>
                  信用卡自動扣款失敗常見原因（僅供參考，詳細原因請洽發卡銀行）
                </div>
                <hr>
                <ol class="lh-lg" style="padding-left: 1.5rem;">
                  <li>信用卡卡號與有效月年輸入錯誤，請確認後再次輸入。</li>
                  <li>信用卡交易系統繁忙，請稍後再試。</li>
                  <li>信用卡收單銀行否認 / 拒絕了您信用卡每月自動扣款的要求，請與您的發卡銀行聯絡。</li>
                  <li>信用卡未通過NCCC(聯合信用卡中心)認證，可能為國外信用卡。</li>
                </ol>
              </div>
            </template>
          </div>
        </div>
        <div class="mt-5">
          <template v-if="orderType === 'reservation'">
            <BaseButton
              :to="{ name: 'reservation-item', params: { reservationAlias: orderItem.param.alias } }"
              replace
              class="isStylePrimary isCol4"
              :class="{ 'isRadius': $globalIsJtails }"
            >
              回服務資訊頁
            </BaseButton>
          </template>
          <template v-if="orderType === 'prepaid'">
            <BaseButton
              :to="{ name: 'prepaid-item', params: { prepaidAlias: orderItem.prepaid.alias } }"
              replace
              class="isStylePrimary isCol4"
              :class="{ 'isRadius': $globalIsJtails }"
            >
              {{`回${currentMerchant.prepaidSetting.title || $t('site.PREPAID_TITLE')}資訊頁`}}
            </BaseButton>
          </template>
          <template v-if="orderType === 'children'">
            <BaseButton
              :to="{ name: 'reservation-checkout-detail', params: { addOrderId: orderItem.id } }"
              replace
              class="isStylePrimary isCol4"
              :class="{ 'isRadius': $globalIsJtails }"
            >
              返回訂單
            </BaseButton>
          </template>
          <template v-if="orderType === 'deposit'">	
            <BaseButton	
              :to="{ name: 'deposit' }"	
              replace	
              class="isStylePrimary isCol4"	
              :class="{ 'isRadius': $globalIsJtails }"
            >	
              回儲值金方案頁	
            </BaseButton>	
          </template>
        </div>
      </template>
    </div>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.checkoutDetailCallback {
  display: flex;
  align-items: center;
  justify-content: center;

  @include var-min-height(100, - 539px);

  @include max-md {
    display: block;

    @include var-min-height(100, - 328px);
  }

  :global {
    .checkoutDetailCallback {
      &__title {
        margin-bottom: 1rem;
        font-size: 1.25rem;
        font-weight: 600;
      }

      &__description {
        margin-bottom: 3rem;
        font-size: 0.875rem;
        color: $color-gray-2;
      }
    }
  }
}

.previousCart {
  padding: 1.875rem;
  padding-top: 5rem !important;
  border: 1px solid rgba($color-primary, 0.5);
  border-radius: 6px;
  box-shadow: none;
  margin-bottom: 1rem;
  position: relative;
  &:before {
    content: '您還有尚未完成的訂單';
    position: absolute;
    top: 20px;
    font-size: 1.5rem;
    left: 0;
    width: 100%;

    @include max-md {
      top: -95px;
    }
  }

  @include max-md {
    padding: 1rem;
  }
  :global {
    div[class*=BaseStoreTagList] {
      z-index: 1;
      position: relative;

      & + .infoBoxPrepaid__title, & + .infoBoxReservation__title {
        &:before {
          top: -100px;
        }

        &:after {
          height: 3rem;
        }
      }
    }

    .infoBoxPrepaid__title, .infoBoxReservation__title {
      position: relative;
      z-index: 0;
      margin-bottom: 1.5rem;
      &:before {
        content: '您還有尚未完成的訂單';
        position: absolute;
        top: -65px;
        font-size: 1.5rem;
        left: 0;
        width: 100%;

        @include max-md {
          top: -95px;
        }
      }

      &:after {
        content: '';
        width: 100%;
        height: 3.125rem;
        border-radius: 6px;
        background: rgba($color-blue, 0.5);
        position: absolute;
        bottom: -10px;
        left: 0;
        z-index: -1;
      }
    }

    .infoBoxPrepaid__info, .infoBoxReservation__info {
      font-size: 1rem;
      text-align: left;
    }

    .FormCoupon {
      display: none;
    }
  }
}
</style>
